import styled from '@emotion/styled';
import {
  getColor,
  getSpace,
  FlexContainer,
  Image,
  GridContainer,
} from '../../../../../../../ui/index.ts';

export const Container = styled(FlexContainer)`
  border-radius: 30px;
  background: ${getColor('light-blue-2')};
  width: 100%;

  @media (max-width: 768px) {
    overflow: hidden;
  }
`;

export const ImageContainer = styled.div`
  width: 100%;
  margin: 0 auto;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;

  @media (max-width: 768px) {
    padding: 0 ${getSpace('10')};
  }
`;

export const OwnerImg = styled(Image)`
  height: auto;
  max-height: 500px;
  display: block;
  z-index: 1;
  object-fit: contain;

  @media (max-width: 768px) {
    max-height: 300px;
  }

  @media (max-width: 425px) {
    max-height: 200px;
  }
`;

export const SchoolsContainer = styled(GridContainer)`
  padding: ${getSpace('20')};
`;

export const SchoolImg = styled(Image)`
  max-width: 300px;
  height: auto;
  max-height: 500px;
  display: block;
  z-index: 1;
  object-fit: cover;

  @media (max-width: 768px) {
    max-height: 75px;
    object-fit: contain;
  }

  @media (max-width: 425px) {
    max-height: 50px;
  }
`;
